import React, { useState, useRef, useEffect } from 'react';
import styles from './partnerConfig.module.css';
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

const MultiDropdown = ({ options, value, onChange, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(Array.isArray(value) ? value : []);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        let normalizedValue = [];
        
        if (Array.isArray(value)) {
            normalizedValue = value.map(item => {
                if (typeof item === 'string') {
                    return item;
                } else if (typeof item === 'object' && item !== null) {
                    const keys = Object.keys(item);
                    return keys.length > 0 ? keys[0] : String(item);
                }
                return String(item);
            });
        } else if (value) {
            normalizedValue = [String(value)];
        }
        
        setSelectedOptions(normalizedValue);
    }, [value]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        if (!isOpen) setSearchTerm('');
    };

    const handleOptionClick = (option) => {
        let newSelectedOptions;
        if (option.toLowerCase() === 'all') {
            if (selectedOptions.includes(option)) {
                newSelectedOptions = selectedOptions.filter(item => item !== option);
            } else {
                newSelectedOptions = [option];
            }
        } else {
            if (selectedOptions.includes(option)) {
                newSelectedOptions = selectedOptions.filter(item => item !== option);
            } else {
                newSelectedOptions = selectedOptions
                    .filter(item => item.toLowerCase() !== 'all')
                    .concat([option]);
            }
        }
        setSelectedOptions(newSelectedOptions);
        onChange(newSelectedOptions);
    };

    const removeOption = (option, e) => {
        e.stopPropagation();
        const newSelectedOptions = selectedOptions.filter(item => item !== option);
        setSelectedOptions(newSelectedOptions);
        onChange(newSelectedOptions);
    };

      const filteredOptions = options?.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className={styles.multiDropdownContainer} ref={dropdownRef}>
            <div
                className={styles.multiDropdownHeader}
                onClick={toggleDropdown}
            >
                {selectedOptions.length > 0 ? (
                    <div className={styles.selectedOptionsList}>
                        {selectedOptions.map((option, index) => (
                            <div key={index} className={styles.selectedOption}>
                                {option}
                                <span
                                    className={styles.removeOption}
                                    onClick={(e) => removeOption(option, e)}
                                >
                                    ✕
                                </span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={styles.placeholder}>{placeholder || 'Select'}</div>
                )}
                <div className={styles.dropdownArrow}> {isOpen ? <IoIosArrowUp size={16} /> : <IoIosArrowDown size={16} />}</div>
            </div>

        {isOpen && (
        <div className={styles.optionsList}>
          <input
            type="text"
            className={styles.searchBox}
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />

          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                className={`${styles.option} ${selectedOptions.includes(option) ? styles.selected : ''}`}
                onClick={() => handleOptionClick(option)}
              >
                {option}
                {selectedOptions.includes(option) && (
                  <span className={styles.checkmark}>✓</span>
                )}
              </div>
            ))
          ) : (
            <div className={styles.noData}>No results found</div>
          )}
        </div>
      )}
        </div>
    );
};

export default MultiDropdown;